module.exports = __webpack_public_path__ + "static/media/image-choice.a35bcded.svg";